import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SchedulerDialogComponent } from './scheduler-dialog.component';
import { MatLegacyDialogModule } from '@angular/material/legacy-dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { CtModelModule } from '@ctsolution/ct-framework';
import { SchedulerLegendModule } from '../scheduler-legend/scheduler-legend.module';

/**
 * Modulo per il componente SchedulerDialog
 * Gestisce lo scheduler in modalità modale
 */
@NgModule({
  declarations: [
    SchedulerDialogComponent
  ],
  imports: [
    CommonModule,
    MatLegacyDialogModule,
    MatIconModule,
    MatLegacyButtonModule,
    CtModelModule,
    SchedulerLegendModule
  ],
  exports: [
    SchedulerDialogComponent
  ]
})
export class SchedulerDialogModule { }
